import { VueReCaptcha } from 'vue-recaptcha-v3'
import { createApp } from 'vue'
import AccommodationContact from '@/components/AccommodationContact'
import AccommodationQuoteForm from '@/components/AccommodationQuoteForm'
import ActivityContact from '@/components/ActivityContact'
import BookingModal from '@/components/BookingModal'
import BuyBookModal from '@/components/BuyBookModal'
import EditUserInfo from '@/components/EditUserInfo'
import LoginForm from '@/components/LoginForm'
import NeedPremiumPopup from '@/components/NeedPremiumPopup'
import PaidPopup from '@/components/PaidPopup'
import PayLaterPopup from '@/components/PayLaterPopup'
import PremiumForm from '@/components/PremiumForm'
import QuoteFormBookBriefing from '@/components/QuoteFormBookBriefing'
import QuoteFormBookHostHotel from '@/components/QuoteFormBookHostHotel'
import QuoteFormStay from '@/components/QuoteFormStay'
import QuoteFormVehicle from '@/components/QuoteFormVehicle'
import ReminderForm from '@/components/ReminderForm'
import SubmissionModal from '@/components/SubmissionModal'
import SuccessBookBriefing from '@/components/SuccessBookBriefing'
import SuccessBookHostHotel from '@/components/SuccessBookHostHotel'
import SuccessQuoteForm from '@/components/SuccessQuoteForm'
import SuccessQuoteFormAccommodation from '@/components/SuccessQuoteFormAccommodation'
import SuccessQuoteFormStay from '@/components/SuccessQuoteFormStay'
import SuccessQuoteFormVehicle from '@/components/SuccessQuoteFormVehicle'
import SuccessReminderForm from '@/components/SuccessReminderForm'
import Localisations from '@/enums/Localisations'
import PremiumType from '@/enums/PremiumType'
import SubmissionType from '@/enums/SubmissionType'
import ModalBus from '@/eventBus'
import translations from '@/translations/translate.json'
import '@/fontawesomeLibrary.js'
import Lang from 'lang.js'
import { deepFreeze } from '@/utils/deepFreeze.js'
import * as scripts from '@/scripts/index.js'

deepFreeze(window.Laravel)

let lang = new Lang({
  messages: translations,
  locale: process.env.MIX_APP_LOCALE,
  fallback: 'default',
})

const app = createApp({
  data() {
    return window.Laravel ?? {}
  },

  mounted() {
    Object.keys(scripts).forEach((key) => scripts[key]())

    const redirectTo = new URLSearchParams(window.location.search).get('redirectTo')

    if (redirectTo) {
      this.openLoginForm({ redirectTo: redirectTo })
    }
  },

  methods: {
    openNeedPremiumPopup: function (data = {}) {
      ModalBus.emit('open', { component: NeedPremiumPopup, props: { ...data } })
    },

    openPremiumFormPopup: function (data = {}) {
      ModalBus.emit('open', { component: PremiumForm, props: { ...data } })
    },

    openPaidPopup: function () {
      ModalBus.emit('open', { component: PaidPopup })
    },

    openPayLaterPopup: function () {
      ModalBus.emit('open', { component: PayLaterPopup })
    },

    openBuyBookModal: function (data = {}) {
      ModalBus.emit('open', { component: BuyBookModal, props: { ...data } })
    },

    openReminderModal: function (data = {}) {
      ModalBus.emit('open', { component: ReminderForm, props: { ...data } })
    },

    openSuccessReminderFormModal: function () {
      ModalBus.emit('open', { component: SuccessReminderForm })
    },

    openQuoteFormVehicle: function (data = {}) {
      ModalBus.emit('open', { component: QuoteFormVehicle, props: { ...data } })
    },

    openSuccessQuoteFormVehicle: function (data = {}) {
      ModalBus.emit('open', { component: SuccessQuoteFormVehicle, props: { ...data } })
    },

    openSuccessBookHostHotel: function (data = {}) {
      ModalBus.emit('open', { component: SuccessBookHostHotel, props: { ...data } })
    },

    openSuccessBookBriefing: function (data = {}) {
      ModalBus.emit('open', { component: SuccessBookBriefing, props: { ...data } })
    },

    openSuccessQuoteFormAccommodation: function (data = {}) {
      ModalBus.emit('open', { component: SuccessQuoteFormAccommodation, props: { ...data } })
    },

    openSuccessQuoteForm: function (data = {}) {
      ModalBus.emit('open', { component: SuccessQuoteForm, props: { ...data } })
    },

    openBookingPopup: function (infos = {}) {
      ModalBus.emit('open', { component: BookingModal, props: { activityInfos: infos } })
    },

    openEditInfosForm: function (data = {}) {
      ModalBus.emit('open', { component: EditUserInfo, props: { ...data } })
    },

    openLoginForm: function (data = {}) {
      ModalBus.emit('open', { component: LoginForm, props: { ...data } })
    },

    openAccommodationQuoteForm: function (data = {}) {
      ModalBus.emit('open', { component: AccommodationQuoteForm, props: { ...data } })
    },

    openAccommodationContact: function (data = {}) {
      ModalBus.emit('open', { component: AccommodationContact, props: { ...data } })
    },

    openActivityContact: function (data = {}) {
      ModalBus.emit('open', { component: ActivityContact, props: { ...data } })
    },

    openSubmissionModal: function (data = {}) {
      ModalBus.emit('open', { component: SubmissionModal, props: { ...data } })
    },

    openBookHostHotelModal: function (data = {}) {
      ModalBus.emit('open', { component: QuoteFormBookHostHotel, props: { ...data } })
    },

    openBookBriefingModal: function (data = {}) {
      ModalBus.emit('open', { component: QuoteFormBookBriefing, props: { ...data } })
    },

    openSuccessQuoteFormStay: function (data = {}) {
      ModalBus.emit('open', { component: SuccessQuoteFormStay, props: { ...data } })
    },

    openQuoteFormStayModal: function (data = {}) {
      ModalBus.emit('open', { component: QuoteFormStay, props: { ...data } })
    },
  },
})

app.config.globalProperties.$enums = { SubmissionType, Localisations, PremiumType }

app.mixin({
  data() {
    return {
      publicPath: process.env.ASSET_URL,
      appName: process.env.MIX_APP_NAME,
      appCountry: process.env.MIX_APP_COUNTRY,
    }
  },

  methods: {
    $t(...args) {
      return args.length === 0 ? lang : lang.get(...args)
    },
  },
})

app.use(VueReCaptcha, {
  siteKey: process.env.MIX_RECAPTCHA_PUBLIC,
  loaderOptions: {
    autoHideBadge: true,
  },
})

const files = import.meta.webpackContext('./components', { recursive: true, regExp: /[.]vue$/ })
files.keys().map((key) => app.component(key.split('/').pop().split('.')[0], files(key).default))

app.mount('#app')
